<template>
  <div>
    <!--  <a-card :bordered="false"> -->
    <div class="page_top">
      <!-- <h1 class="title_from">
        <b>{{ formTitle }}</b>
      </h1> -->
      <div class="dis_flex">
        <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
        <h2 class="title_from">{{ formTitle }}</h2>
      </div>
      <!-- <a-button class="" type="link" @click="$router.go(-1)">
        <a-icon type="left-circle" />
      </a-button> -->
    </div>

    <div class="page_con">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">
        <h3 class="page_item_title">基本信息</h3>
        <a-form-model-item colon label="职级名称" prop="rankName">
          <a-input class="w360" v-model="dataInfo.rankName" :maxLength="20" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item colon label="起提点" prop="originatingPoint">
          <!-- <a-input :maxLength="15"-number
            v-model="dataInfo.originatingPoint"
            :default-value="100"
            :min="0"
            :max="100"
            @change="pointChange"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
          /> -->
          <a-input :maxLength="15" size="default" class="w360" v-model="dataInfo.originatingPoint" suffix="%" />
        </a-form-model-item>

        <h3 class="page_item_title">升级标准</h3>
        <div style="display: flex">
          <a-form-model-item colon label="司龄" prop="workAge">
            <a-input :maxLength="15" v-model="dataInfo.workAge" size="default" placeholder="请输入" />
          </a-form-model-item>

          <a-form-model-item
            colon
            label="单位"
            prop="workAgeUnit"
          ><!-- 司龄 -->
            <a-select v-model="dataInfo.workAgeUnit" class="w120" placeholder="请选择">
              <a-select-option value="年">年</a-select-option>
              <a-select-option value="月">月</a-select-option>
              <a-select-option value="日">日</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item colon label="入司累计业绩" prop="workPerformance" style="margin-left: 10px">
            <!-- <a-input :maxLength="15"-number
              v-model="dataInfo.workPerformance"
              size="default"
              :default-value="0"
              :step="0.01"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}元`"
              :parser="(value) => value.replace('元', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.workPerformance" suffix="元" />
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">降级标准</h3>
        <a-form-model-item colon label="季度平均业绩" prop="quarterlyAveragePerformance">
          <!-- <a-input :maxLength="15"-number
            size="default"
            v-model="dataInfo.quarterlyAveragePerformance"
            :step="0.01"
            :default-value="0"
            :min="0"
            @change="pointChange"
            :formatter="(value) => `${value}元`"
            :parser="(value) => value.replace('元', '')"
          /> -->
          <a-input
            :maxLength="15"
            size="default"
            class="w360"
            v-model="dataInfo.quarterlyAveragePerformance"
            suffix="元"
          />
        </a-form-model-item>

        <h3 class="page_item_title">绩效指标</h3>
        <div style="display: flex; flex-wrap: wrap">
          <a-form-model-item class="item_kpi" colon label="房源新增" prop="houseAdd">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.houseAdd"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}个/月`"
              :parser="(value) => value.replace('个/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.houseAdd" suffix="个/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="客源新增" prop="lesseeAdd">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.lesseeAdd"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}个/月`"
              :parser="(value) => value.replace('个/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.lesseeAdd" suffix="个/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="带看" prop="takeLook">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.takeLook"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.takeLook" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="一带多看" prop="inMore">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.inMore"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.inMore" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="一客多看" prop="lesseeSeeMore">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.lesseeSeeMore"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.lesseeSeeMore" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="业绩" prop="performanceAmount">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.performanceAmount"
              :step="0.01"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}元/月`"
              :parser="(value) => value.replace('元/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.performanceAmount" suffix="元/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="面访" prop="interview">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.interview"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}个/月`"
              :parser="(value) => value.replace('个/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.interview" suffix="个/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="委托" prop="entrustNum">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.entrustNum"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}份/月`"
              :parser="(value) => value.replace('份/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.entrustNum" suffix="份/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="钥匙" prop="keysNum">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.keysNum"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}间/月`"
              :parser="(value) => value.replace('间/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.keysNum" suffix="间/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="客源跟进" prop="guestFollowUp">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.guestFollowUp"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.guestFollowUp" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="房源跟进" prop="houseFollowUp">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.houseFollowUp"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.houseFollowUp" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="五房被带看量" prop="byTakeLookHouseNum">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.byTakeLookHouseNum"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.byTakeLookHouseNum" suffix="次/月" />
          </a-form-model-item>
          <a-form-model-item class="item_kpi" colon label="五客带看量" prop="takeLookLesseeNum">
            <!-- <a-input :maxLength="15"-number
              size="default"
              v-model="dataInfo.takeLookLesseeNum"
              :default-value="0"
              :min="0"
              @change="pointChange"
              :formatter="(value) => `${value}次/月`"
              :parser="(value) => value.replace('次/月', '')"
            /> -->
            <a-input :maxLength="15" size="default" v-model="dataInfo.takeLookLesseeNum" suffix="次/月" />
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">业绩分配</h3>
        <div style="display: flex; flex-direction: column" id="achiList">
          <div class="item_achi dis_flex" v-for="(achiObj, index) in dataInfo.boList" :key="index">
            <a-form-model-item class="item_" colon label="业绩范围" :required="true">
              <a-input
                :maxLength="15"
                class="w120"
                v-model="achiObj.performanceStartAmount"
                @blur="validateFloat(achiObj.performanceStartAmount)"
                suffix="元"
              />
              ——
              <a-input
                :maxLength="15"
                class="w120"
                v-model="achiObj.performanceEndAmount"
                @blur="validateFloat(achiObj.performanceEndAmount)"
                suffix="元"
              />
            </a-form-model-item>

            <a-form-model-item colon label="提成比例" :required="true" style="margin-left: 10px">
              <a-input
                :maxLength="15"
                size="default"
                v-model="achiObj.contractRatio"
                @blur="validateFloat(achiObj.contractRatio)"
                suffix="%"
              />
            </a-form-model-item>
            <a-form-model-item style="margin-left: 10px">
              <a-button class="ml20" v-if="index > 0" type="link" @click="removeAchi(index, achiObj.id)">
                <a-icon type="minus-circle" :style="{ fontSize: '24px', color: 'red' }" />
              </a-button>
            </a-form-model-item>
          </div>
        </div>
        <a-button type="link" @click="addAchi">
          <a-icon type="plus-circle" :style="{ fontSize: '24px', color: 'var(--ThemeColor)' }" />
        </a-button>
        <div style="width: 100%; height: 50px"></div>

        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
            <a-button type="dashed" @click="goList"> 取消 </a-button>
          </a-space>
        </div>
      </a-form-model>
      <!-- </a-card> -->
    </div>
  </div>
</template>

<script>
import { getProfession, addProfession, updateProfession, delProfessionAllotSet } from '@/api/system/profession'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data () {
    return {
      submitLoading: false,
      formTitle: '编辑职级信息',
      // 表单参数
      dataInfo: {
        boList: [
          // 职级管理 业绩分配设置业务对象list
          {
            contractRatio: undefined, // 提成比例
            id: undefined, // 新增时不传，修改时必传
            rankId: undefined,
            performanceEndAmount: undefined, // 业绩范围最大金额
            performanceStartAmount: undefined // 业绩范围最小金额
          }
        ], // 业绩分配list
        byTakeLookHouseNum: undefined, // 五房被带看量（次/月）
        entrustNum: undefined, //	委托（份/月）
        guestFollowUp: undefined, //	客源跟进（次/月）
        houseAdd: undefined, //	房源新增（个/月）
        houseFollowUp: undefined, //	房源跟进（次/月）
        id: undefined, // 新增时不传，修改时必传
        inMore: undefined, //	一带多看（次/月）
        interview: undefined, //	面访（个/月）
        keysNum: undefined, // 钥匙（间/月）
        lesseeAdd: undefined, //	客源新增（个/月）
        lesseeSeeMore: undefined, //	一客多看（次/月）
        originatingPoint: undefined, //	起提点（百分比）
        performanceAmount: undefined, //	业绩（元/月）
        quarterlyAveragePerformance: undefined, //	季度平均业绩（元）
        rankName: undefined, //	职级名称
        takeLook: undefined, //	带看（次/月）
        takeLookLesseeNum: undefined, //	五客带看量（次/月）
        workAge: undefined, //	司龄
        workAgeUnit: undefined, //	司龄单位
        workPerformance: undefined //	入司累计业绩（元）
      },
      open: true,
      keyId: undefined,
      rules: {
        boList: [{ required: true, message: '业绩分配信息不能为空', trigger: 'blur' }],
        // achiObj_performanceAmount: [{ required: true, message: '必填' }],
        // achiObj_contractRatio: [{ required: true, message: '必填' }],
        byTakeLookHouseNum: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 五房被带看量不能为空
        entrustNum: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 委托量不能为空
        guestFollowUp: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 客源跟进量不能为空
        houseAdd: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 房源新增量不能为空
        houseFollowUp: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 房源跟进量不能为空
        inMore: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 一带多看量不能为空
        // id: undefined,//新增时不传，修改时必传
        interview: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 面访量不能为空
        keysNum: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 钥匙量不能为空
        lesseeAdd: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 客源新增量不能为空
        lesseeSeeMore: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 一客多看量不能为空
        originatingPoint: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ], // 起提点不能为空
        performanceAmount: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ], // 业绩不能为空
        quarterlyAveragePerformance: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ], // 季度平均业绩不能为空
        rankName: [{ required: true, message: '必填', trigger: 'blur' }], // 职级名称不能为空
        takeLook: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 带看量不能为空
        takeLookLesseeNum: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 五客带看量不能为空
        workAge: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }], // 司龄不能为空
        workAgeUnit: [{ required: true, message: '必选', trigger: 'blur' }], // 司龄单位不能为空
        workPerformance: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ] // 入司累计业绩不能为空
      }
    }
  },
  filters: {
    filterConcatStr (val, prefix, suffix) {
      return prefix + val + suffix
    }
  },
  created () {
    this.reset()
    let professionId = this.$route.query.dataId
    if (professionId !== '' && professionId != null && typeof professionId !== 'undefined') {
      professionId = parseInt(this.$route.query.dataId)
      this.dataInfo.keyId = professionId
      getProfession(professionId).then((response) => {
        this.dataInfo = response.data
        this.dataInfo.boList = response.data.allotSetVoList
        this.$forceUpdate()
        // console.log(this.dataInfo);
        // this.open = true
        this.formTitle = '修改职级'
      })
    } else {
      this.formTitle = '新增职级'
    }
  },
  computed: {},
  watch: {},
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.dataInfo = {
        boList: [
          // 职级管理 业绩分配设置业务对象list
          {
            contractRatio: undefined, // 提成比例
            id: undefined, // 新增时不传，修改时必传
            rankId: this.keyId,
            performanceEndAmount: undefined, // 业绩范围最大金额
            performanceStartAmount: undefined // 业绩范围最小金额
          }
        ], // 业绩分配list
        byTakeLookHouseNum: undefined, // 五房被带看量（次/月）
        entrustNum: undefined, //	委托（份/月）
        guestFollowUp: undefined, //	客源跟进（次/月）
        houseAdd: undefined, //	房源新增（个/月）
        houseFollowUp: undefined, //	房源跟进（次/月）
        id: undefined, // 新增时不传，修改时必传
        inMore: undefined, //	一带多看（次/月）
        interview: undefined, //	面访（个/月）
        keysNum: undefined, // 钥匙（间/月）
        lesseeAdd: undefined, //	客源新增（个/月）
        lesseeSeeMore: undefined, //	一客多看（次/月）
        originatingPoint: undefined, //	起提点（百分比）
        performanceAmount: undefined, //	业绩（元/月）
        quarterlyAveragePerformance: undefined, //	季度平均业绩（元）
        rankName: undefined, //	职级名称
        takeLook: undefined, //	带看（次/月）
        takeLookLesseeNum: undefined, //	五客带看量（次/月）
        workAge: undefined, //	司龄
        workAgeUnit: undefined, //	司龄单位
        workPerformance: undefined //	入司累计业绩（元）
      }
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '添加职级'
    },
    validateFloat (val, msg) {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      const re = new RegExp(reg)
      if (re.test(val)) {
        return true
      } else {
        this.$message.error(msg || '业绩未填写完整或格式错误', 3)
        return false
      }
    },
    validateMinMax (sAmount, eAmount, msg) {
      if (parseFloat(sAmount) <= parseFloat(eAmount)) {
        return true
      } else {
        this.$message.error(msg || '范围数据不合法', 3)
        return false
      }
    },
    validateMoney () {
      const boList_ = this.dataInfo.boList
      let sAmount = 0
      let eAmount = 0
      let contractRatio = 0
      let flag = true
      if (boList_ && boList_.length > 0) {
        for (const bo of boList_) {
          sAmount = bo.performanceStartAmount
          eAmount = bo.performanceEndAmount
          contractRatio = bo.contractRatio
          flag = flag && (this.validateFloat(sAmount, '业绩起始值未填写完整或格式错误')) &&
            (this.validateFloat(eAmount, '业绩终止值未填写完整或格式错误')) &&
            (this.validateFloat(contractRatio, '业绩提成比例未填写完整或格式错误')) &&
            this.validateMinMax(sAmount, eAmount, '业绩终止值不可低于业绩起始值')
        }
         return flag
      } else {
        this.$message.error('业绩范围至少一条', 3)
        return false
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      if (!this.validateMoney()) {
        // this.$message.error('业绩范围未填写或格式错误', 3)
        return
      }
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateProfession(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.goList()
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addProfession(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.goList()
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    pointChange (value) {
      console.log('changed', value)
    },
    addAchi () {
      const obj = {
        contractRatio: undefined, // 提成比例
        rankId: this.keyId,
        id: undefined, // 新增时不传，修改时必传
        performanceEndAmount: 0, // 业绩范围最大金额
        performanceStartAmount: 0 // 业绩范围最小金额
      }
      this.dataInfo.boList.push(obj)
      this.$forceUpdate()
      console.log(this.dataInfo.boList)
    },
    removeAchi (idx, id) {
      if (id) {
        this.deleteperformanceAllotSetHandle(id)
      }

      this.dataInfo.boList.splice(idx, 1)
      this.$forceUpdate()
    },
    // 删除业绩分配设置
    deleteperformanceAllotSetHandle (ids) {
      delProfessionAllotSet(ids)
        .then((response) => {
          this.$message.success('业绩分配设置删除成功', 3)
        })
        .finally(() => {})
    },
    goList () {
      this.$router.push({ path: '/system/profession' })
    }
  }
}
</script>
<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.ml20 {
  margin-left: 20px;
}
.w120 {
  width: 120px;
}
.w360 {
  width: 360px;
}
.page_top,
.page_con {
  background: #fff;
  padding: 20px;
}
.page_top {
  display: flex;
}
.page_con {
  margin-top: 10px;
}
.title_from {
  font-size: @titleFontSize;
  color: @titleColor;
  margin-bottom: 0;
}
.dis_flex {
  display: flex;
  align-items: center;
}
.page_item_title {
  font-size: 16px;
  color: @titleColor;
  font-weight: bold;
}
.item_kpi {
  margin-right: 10px;
  width: 18%;
}
.dis_flex {
  display: flex;
}
.item_achi {
  align-items: flex-end;
}
</style>
